import React from 'react';
import Icon from '../ui/Icon';
import Modal from '../ui/Modal';
import styles from './EmailPreview.module.css';

// 375x667 — a real mobile mail-client viewport (roughly iPhone SE), not an
// arbitrary box. Rendering the iframe at this size means the email's own
// responsive/media-query CSS behaves exactly as it would on-device; the
// small inline slot then uniformly scales the *whole* rendered result down
// (width and height by the same factor) rather than squeezing content into
// an artificially narrow box, which is what made the old fixed 240x380
// preview look wrong.
const DEVICE_W = 375;
const DEVICE_H = 667;
const SLOT_W = 240;
const SLOT_SCALE = SLOT_W / DEVICE_W;

function Frame({ subject, html, scale }) {
  return (
    <div style={{ width: DEVICE_W * scale, height: DEVICE_H * scale }}>
      <div className={styles.client} style={{ width: DEVICE_W, height: DEVICE_H, transform: `scale(${scale})`, transformOrigin: 'top left' }}>
        <div className={styles.clientBar}>
          <span className={styles.dot} /><span className={styles.dot} /><span className={styles.dot} />
        </div>
        <div className={styles.subjectRow}>
          <span className={styles.subjectLabel}>Subject</span>
          <span className={styles.subjectText}>{subject || 'Your campaign subject'}</span>
        </div>
        <iframe
          title="Email body preview"
          className={styles.frame}
          sandbox=""
          srcDoc={html || '<p style="font-family: sans-serif; color: #999;">Your email body appears here…</p>'}
        />
      </div>
    </div>
  );
}

// Literal preview — subject/html are exactly what email.provider.js sends
// (see sesv2 SendEmailCommand in that file), so this renders the real thing,
// not a structural approximation.
class EmailPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  render() {
    const { subject = '', html = '' } = this.props;
    const { expanded } = this.state;
    return (
      <div className={styles.wrap}>
        <div className={styles.labelRow}>
          <span className={styles.label}>Live Preview</span>
          <button type="button" className={styles.expandBtn} title="Enlarge preview" onClick={() => this.setState({ expanded: true })}>
            <Icon name="open_in_full" size={11} />
          </button>
        </div>
        <Frame subject={subject} html={html} scale={SLOT_SCALE} />
        <div className={styles.caption}>Real device viewport, scaled · preview only</div>

        <Modal open={expanded} onClose={() => this.setState({ expanded: false })} title="Email — full preview" width="fit-content">
          <Frame subject={subject} html={html} scale={1} />
        </Modal>
      </div>
    );
  }
}

export default EmailPreview;
